module.exports = __webpack_public_path__ + "static/img/placeholder.01b2890.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bel9850/placeholder.png
// module id = HF3a
// module chunks = 0